pyzel.homepage = pyzel.homepage || {};

pyzel.homepage.big_rectangles = {

	init: function(){

		let html = '';
		//let loops = 0;
		let col_class = 'col-sm-6';

		$.ajax({

			url: endpoint+'/cms/zones/64/objects',
			method: 'get'

		}).done( r => {

			//$.each( r, function(){				
			$.each( r, ( k, i ) =>{

				//loops++;

				if( k == 2 ) col_class = 'col-sm-12';

				html = 

				`<div class="${ col_class }">
					<a href="${ i.hpurl || '#' }" class="image-highlight">
						<div class="image">
							<img src="${ i.bannerimg }" alt="${ i.hptitle }">
						</div>
						<div class="description large">
							${ i.hptitle }
						</div>
					</a>
				</div>`;	

				$('#big-rectangles').append( html );

			})

		})

	}
	

}